export default (() => {

    const global = {
        elements: {},
        pageData: {},
        requestData: {},
    };

    function initialise (config) {
        _cacheDom();
        _cachePageData(config);
        _bindEvents();
        _addContentToManualTransferModals();
    }

    function _cacheDom () {
        global.elements.manualTransferModals = [...document.querySelectorAll('[data-manual-transfer-modal]')];
        global.elements.timelineMessages = [...document.querySelectorAll('[data-timeline-message')];
        global.elements.hideMessagesButton = document.querySelector('[data-button-hide-messages]');
        global.elements.showMessagesButton = document.querySelector('[data-button-show-messages]');
    }

    function _cachePageData(config){
        global.pageData.contributorId = config.contributorId;
        global.pageData.portfolioId = config.portfolioId;

        global.requestData.setShowMessagesUrl = config.setShowMessagesUrl;
    }

    function _bindEvents(){
        if(global.elements.hideMessagesButton){
            global.elements.hideMessagesButton.addEventListener('click', () => _hideShowMessages(false));
        }

        if(global.elements.showMessagesButton){
            global.elements.showMessagesButton.addEventListener('click', () => _hideShowMessages(true));
        }
    }

    function _hideShowMessages(visible){
        global.elements.hideMessagesButton.classList[visible ? 'remove' : 'add']('u-display__none');
        global.elements.showMessagesButton.classList[visible ? 'add' : 'remove']('u-display__none');
        
        global.elements.timelineMessages.forEach(e => e.classList[visible ? 'remove' : 'add']('u-display__none'));

        const config = {
            url: global.requestData.setShowMessagesUrl,
            method: 'PUT',
            data: {
                contributorId: global.pageData.contributorId,
                portfolioId: global.pageData.portfolioId,
                visible: visible
            }
        };

        wealthify.request.send(config);
    }

    function _addContentToManualTransferModals () {
        Array.prototype.forEach.call(global.elements.manualTransferModals, (modal) => {
            const transactionId = modal.getAttribute('data-manual-transfer-modal');
            const config = {
                method: 'GET',
                url: `/Contributor/ContributionModal?id=${transactionId}`
            };

            wealthify.request.send(config).then((response) => {
                wealthify.dom.moveContentBetweenNodes(wealthify.dom.fromString(`<div>${response}</div>`), modal);
            });
        });
    }

    return {initialise};
})();